export default __webpack_public_path__ + "google_classroom_grey_stroke_icon.png";